export default import.meta.ROLLDOWN_FILE_URL_SrzbYP8VFbfrjPW0RDTHHg